import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    selector: 'footer-main',
    styleUrls: ['./footer-main.scss'],
    templateUrl: './footer-main.html',
    standalone: true,
    imports: [CommonModule]
})
export class FooterComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  supportURL: string = environment.supportURL;
  webURL: string = environment.webURL;
  slug: string | null = 'global';
  match: boolean = false;
  country: any;
  countries: any[] = globals.countries.filter((site: { active: boolean; }) => site.active);
  gigs: boolean = false;
  jobs: boolean = false;
  vols: boolean = false;
  ads: boolean = false;
  payments: boolean = false;
  support: boolean = false;
  company: boolean = false;
  profile: boolean = false;
  show: boolean = false;

  constructor(
    public auth: AuthService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('slug')) {
      this.slug = this.route.snapshot.paramMap.get('slug');
    } else {
      this.slug = 'global';
    }
    this.countries.forEach((country, i) => {
      if (this.slug == country.slug) {
        this.country = country;
      }
    })
  }

  logout() {
    this.auth.signOut();
  }
}
